var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5V9.5H7.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84 9.5C5.43 7.88 6.53 6.5 7.97 5.57C9.41 4.64 11.11 4.21 12.81 4.35C14.52 4.49 16.13 5.18 17.41 6.32C18.68 7.46 19.55 8.99 19.87 10.67C20.2 12.36 19.97 14.1 19.21 15.64C18.46 17.18 17.23 18.43 15.71 19.21C14.18 19.99 12.44 20.25 10.75 19.96C9.06 19.66 7.52 18.82 6.35 17.57",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReset;